export default "__VITE_ASSET__DYO7GZRZ__"